<template>
	<DaModalFrame v-model:open="modalIsOpen" @close="closeModelParent">
		<DeleteConfirm
			v-if="isReteach && !isEditModal && !openModal"
			v-model:is-no-repeat="isNoRepeatReTeach"
			v-model:successfully="isSuccess"
			:is-re-teach="true"
			@close="closeModal"
			@submit="deleteGoal(idSelected)"
		/>
		<DeleteConfirm
			v-if="!isReteach && !isEditModal && !openModal"
			v-model:is-no-repeat="isNoRepeat"
			v-model:successfully="isSuccess"
			@close="closeModal"
			@submit="deleteGoal(idSelected)"
		/>
		<ChangeApplyDate
			v-if="openModal"
			@close="closeModal"
			@submit="changeDate"
			:applyDate="data?.apply_date"
			:studentId="student_id"
			:planId="plan_id"
		>
		</ChangeApplyDate>
	</DaModalFrame>
	<div :class="isEditModal ? 'side-over--active' : ''">
		<div
			v-if="isEditModal"
			class="
				fixed
				h-screen
				w-screen
				top-0
				left-0
				bg-black
				opacity-20
				z-30
			"
			@click="isEditModal = false"
		></div>
		<EditGoalSideOver
			v-model:data="editData"
			v-model:error="errorEdit"
			v-model:skills="skills"
			:show="isEditModal"
			@close="closeModal"
			@submit="editSubmit"
		/>
	</div>
	<div v-if="isCompleted" class="w-full px-6">
		<div class="py-12 flex items-center justify-between">
			<div
				class="
					text-3xl
					font-bold
					text-neutral-500
					whitespace-nowrap
					md-down:text-xl
				"
			>
				Kế hoạch {{ data?.order }}
			</div>
			<div class="cursor-pointer">
				<svg
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
					@click="$emit('close')"
				>
					<path
						clip-rule="evenodd"
						d="M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z"
						fill="#94A3B8"
						fill-rule="evenodd"
					/>
				</svg>
			</div>
		</div>
		<div class="p-6 bg-white rounded-2xl">
			<div>
				<div class="flex items-center justify-between mb-4">
					<div class="font-semibold text-neutral-500">
						Thống kê chung
					</div>
					<div class="flex items-center gap-2">
						<div class="font-semibold text-neutral-500 text-right">
							Ngày áp dụng:
							{{ $filters.formatDate2(data?.apply_date) }}
						</div>
						<div
							class="cursor-pointer"
							@click="openChangeApplyDate"
						>
							<svg
								width="20"
								height="20"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M15.4041 8.49733L17.1377 6.76375L17.1377 6.76374L17.1377 6.76372C17.6368 6.26463 17.8863 6.01508 18.0269 5.74991C18.3376 5.164 18.3376 4.46221 18.0269 3.8763C17.8863 3.61112 17.6368 3.36156 17.1377 2.86246C16.6386 2.36335 16.389 2.11379 16.1238 1.97321C15.5379 1.66258 14.8361 1.66258 14.2502 1.97321C13.985 2.11379 13.7355 2.36335 13.2364 2.86246L11.4807 4.61818C12.4198 6.22874 13.772 7.57058 15.4041 8.49733ZM10.0262 6.07265L3.36419 12.7346C2.93913 13.1597 2.7266 13.3722 2.58687 13.6333C2.44713 13.8944 2.38819 14.1891 2.27029 14.7786L1.67957 17.7322C1.61305 18.0648 1.57979 18.2311 1.6744 18.3257C1.76901 18.4203 1.93531 18.3871 2.26792 18.3206L5.22152 17.7298C5.81098 17.6119 6.1057 17.553 6.3668 17.4133C6.6279 17.2735 6.84043 17.061 7.26549 16.6359L13.9459 9.95556C12.3647 8.96432 11.027 7.63576 10.0262 6.07265Z"
									fill="#F0BB4F"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div class="grid grid-cols-1 md:grid-cols-3">
				<div
					class="
						p-3
						border
						md:rounded-tl-lg
						border-neutral-200
						w-full
						md-down:rounded-t md-down:rounded-b-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						{{ skills_count || 0 }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số lĩnh vực
						</span>
					</div>
				</div>
				<div
					class="
						p-3
						border border-neutral-200
						w-full
						md:border-l-0
						md-down:border-t-0
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ goals_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số mục tiêu</span
						>
					</div>
				</div>
				<div
					class="
						p-3
						border border-neutral-200
						w-full
						md:rounded-tr-lg md:border-l-0
						md-down:border-t-0
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ continued_goals_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Mục tiêu lặp lại</span
						>
					</div>
				</div>
				<div
					class="
						p-3
						border border-neutral-200
						w-full
						border-t-0
						md:rounded-bl-lg
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ new_goals_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Mục tiêu mới</span
						>
					</div>
				</div>
				<div
					class="
						p-3
						border border-neutral-200
						w-full
						md:border-l-0
						border-t-0
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ goals_from_lib_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Từ Ngân hàng MT</span
						>
					</div>
				</div>
				<div
					class="
						p-3
						border border-t-0
						md:border-l-0 md:rounded-br-lg
						border-neutral-200
						w-full
						md-down:rounded-b md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ goals_from_stopped_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Từ MT tạm dừng</span
						>
					</div>
				</div>
			</div>
		</div>
		<div v-if="isShow" class="mt-8">
			<div
				class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
			>
				<div class="relative">
					<div>
						<img
							alt="luca-logo"
							height="24"
							src="@/assets/images/logo/logo.svg"
							width="35"
						/>
					</div>
					<div class="mt-3 text-neutral-600 text-sm">
						Chọn “Không dạy MT” hoặc “Xoá” để bỏ MT ra khỏi Kế hoạch
						này
					</div>
					<div class="top-1 right-2 absolute cursor-pointer">
						<svg
							fill="none"
							height="12"
							viewBox="0 0 12 12"
							width="12"
							xmlns="http://www.w3.org/2000/svg"
							@click="isShow = false"
						>
							<path
								clip-rule="evenodd"
								d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 10.2929 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
								fill="#E5A42B"
								fill-rule="evenodd"
							/>
						</svg>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div v-for="(goal, index) in goals" :key="index" class="my-10">
				<div class="font-semibold text-lg text-neutral-600 mb-4">
					{{ index + 1 }}. {{ goal.skill.name }} ({{
						goal.goals.length
					}})
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden">
					<div class="__record__table overflow-x-auto scroll-bar">
						<div class="overflow-hidden sm:rounded-t-2xl">
							<table class="divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-12
												whitespace-nowrap
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												w-full
											"
											scope="col"
											style="min-width: 160px"
										>
											Nội dung
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(g, i) in goal.goals"
										:key="g.goal_id"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
												flex
											"
										>
											<div class="ml-2">
												{{ i + 1 }}
											</div>
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div class="flex items-center">
												<router-link
													:to="`/goal/${id}/${g.goal_id}`"
												>
													<div
														class="
															mr-2
															hover:text-yellow-700
															hover:underline
														"
														v-html="
															g.goal_name ||
															g.name
														"
													></div>
												</router-link>
												<TooltipGoalDetail
													:goal-id="g.goal_id || g.id"
													:student-id="id"
												/>
											</div>
											<div
												v-if="
													(g?.assistance_levels &&
														org.enable_goal_assistance_level) ||
													g?.raw_source
												"
												class="flex gap-2 flex-wrap"
												style="max-width: 360px"
											>
												<div
													v-if="g?.raw_source"
													class="
														mt-1
														py-0.5
														px-2.5
														rounded-full
														bg-neutral-200
														text-neutral-700
														h-fit
														w-fit
														whitespace-nowrap
														font-semibold
														shadow-input
													"
													style="font-size: 10px"
												>
													{{ g?.display_source }}
												</div>
												<template
													v-if="
														g?.assistance_levels &&
														org.enable_goal_assistance_level
													"
													class="flex gap-2"
												>
													<div
														v-for="ass in g?.assistance_levels"
														:key="ass"
													>
														<div
															class="
																mt-1
																py-0.5
																px-2.5
																rounded-full
																bg-pink-100
																whitespace-nowrap
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																shadow-input
															"
															style="
																font-size: 10px;
															"
														>
															{{ ass }}
														</div>
													</div>
												</template>
												<div
													class="
														mt-1
														py-0.5
														px-2.5
														rounded-full
														bg-yellow-tag
														text-neutral-700
														h-fit
														w-fit
														font-semibold
														shadow-input
														whitespace-nowrap
													"
													style="font-size: 10px"
													v-if="g?.age"
												>
													{{ g?.age }}
												</div>
											</div>
											<div
												v-if="
													g.parent?.sub_goal_count > 0
												"
												class="
													goal-block
													flex
													gap-3
													mt-2
												"
											>
												<img
													class="w-3 h-3 mt-1"
													src="@/assets/images/icons/goal-arrow.png"
													alt=""
												/>
												<div>
													<div
														class="text-neutral-700"
													>
														{{ g.parent?.name }}
													</div>
													<div
														class="
															text-neutral-400
															text-xs
															font-semibold
														"
													>
														{{
															g.parent
																?.sub_goal_count
														}}
														MỤC TIÊU
													</div>
												</div>
											</div>
											<div class="mt-6">
												<div
													v-if="
														g.allow_remove_from_plan ||
														g.editable
													"
													class="
														flex
														items-center
														justify-end
														md-down:flex-col
														md-down:items-end
														md-down:gap-4
													"
												>
													<div
														v-if="
															g.allow_remove_from_plan
														"
														class="
															cursor-pointer
															text-yellow-600
															hover:text-yellow-700
															font-semibold
															text-sm
															flex
															items-center
															md-down:items-right
															capitalize
														"
														@click="
															deleting(
																g.goal_id ||
																	g.id
															)
														"
													>
														<svg
															class="mr-2"
															fill="none"
															height="16"
															viewBox="0 0 16 16"
															width="16"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																fill="currentColor"
																fill-rule="evenodd"
															/>
														</svg>
														XOÁ
													</div>
													<div
														v-else
														class="
															cursor-pointer
															text-yellow-600
															hover:text-yellow-700
															font-semibold
															text-sm
															flex
															items-center
															md-down:items-right
															whitespace-nowrap
															ml-6
														"
														@click="
															deleting(
																g.goal_id ||
																	g.id,
																true
															)
														"
													>
														<svg
															class="mr-2"
															fill="none"
															height="9"
															viewBox="0 0 9 9"
															width="9"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M0.224562 0.224776C0.46864 -0.0193019 0.864368 -0.0193019 1.10845 0.224776L4.4165 3.53283L7.72456 0.224776C7.96864 -0.0193019 8.36437 -0.0193019 8.60845 0.224776C8.85252 0.468853 8.85252 0.864582 8.60845 1.10866L5.30039 4.41672L8.60845 7.72478C8.85252 7.96885 8.85252 8.36458 8.60845 8.60866C8.36437 8.85274 7.96864 8.85274 7.72456 8.60866L4.4165 5.3006L1.10845 8.60866C0.864368 8.85274 0.46864 8.85274 0.224562 8.60866C-0.0195155 8.36458 -0.0195155 7.96885 0.224562 7.72478L3.53262 4.41672L0.224562 1.10866C-0.0195155 0.864582 -0.0195155 0.468853 0.224562 0.224776Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
														</svg>
														KHÔNG DẠY MT
													</div>
													<div
														v-if="g.editable"
														class="
															cursor-pointer
															text-yellow-600
															hover:text-yellow-700
															font-semibold
															text-sm
															flex
															items-center
															md-down:items-right
															whitespace-nowrap
															ml-6
															capitalize
														"
														@click="
															editGoalModal(g)
														"
													>
														<svg
															class="mr-2"
															fill="none"
															height="16"
															viewBox="0 0 16 16"
															width="16"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M12.4702 6.65087L13.7102 5.41084C13.8461 5.27498 13.914 5.20705 13.9667 5.14509C14.6009 4.39841 14.6009 3.30223 13.9667 2.55555C13.914 2.49359 13.8461 2.42566 13.7102 2.2898C13.5744 2.15394 13.5064 2.08601 13.4445 2.03338C12.6978 1.39915 11.6016 1.39915 10.855 2.03338C10.793 2.086 10.7251 2.15391 10.5893 2.2897L10.5892 2.28978L10.5892 2.2898L9.33099 3.54801C10.0747 4.84221 11.1583 5.91748 12.4702 6.65087ZM7.87633 5.00267L2.86273 10.0163C2.43767 10.4413 2.22514 10.6539 2.0854 10.915C1.94567 11.1761 1.88672 11.4708 1.76883 12.0602L1.37318 14.0385C1.30666 14.3711 1.27339 14.5374 1.368 14.632C1.46261 14.7266 1.62892 14.6934 1.96153 14.6269L3.9398 14.2312L3.93982 14.2312L3.93984 14.2312C4.52927 14.1133 4.82399 14.0544 5.08508 13.9146C5.34617 13.7749 5.55869 13.5624 5.98373 13.1373L5.98376 13.1373L5.98377 13.1373L11.0118 8.10931C9.7511 7.3111 8.68202 6.24922 7.87633 5.00267Z"
																fill="#E5A42B"
																fill-rule="evenodd"
															/>
														</svg>

														CHỈNH SỬA
													</div>
												</div>
												<div
													v-else
													class="
														flex
														items-center
														justify-end
														md-down:flex-col
														md-down:items-end
														md-down:gap-4
													"
												>
													<Popper
														:arrow="true"
														hover
														placement="top"
													>
														<div
															class="
																cursor-pointer
															"
														>
															<svg
																fill="none"
																height="16"
																viewBox="0 0 16 16"
																width="16"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM5.49634 6.03271C5.3599 6.03271 5.24752 5.92237 5.25511 5.78615C5.34964 4.09061 6.73831 3.5 8.00539 3.5C9.40188 3.5 10.6778 4.22998 10.6778 5.74072C10.6778 6.81982 10.043 7.33398 9.43361 7.79736C8.69729 8.35596 8.42434 8.56543 8.42434 9.28271V9.38818C8.42434 9.52625 8.31241 9.63818 8.17434 9.63818H7.36332C7.22658 9.63818 7.11521 9.52833 7.11334 9.39161L7.11037 9.1748C7.07229 8.24805 7.60549 7.67676 8.27834 7.18799C8.86867 6.74365 9.24318 6.45166 9.24318 5.81689C9.24318 4.9917 8.61477 4.64893 7.92922 4.64893C7.1265 4.64893 6.67618 5.12718 6.58723 5.78331C6.56868 5.92013 6.45889 6.03271 6.32082 6.03271H5.49634ZM7.82131 12.4756C7.23732 12.4756 6.81203 12.082 6.81203 11.5488C6.81203 10.9966 7.23732 10.6094 7.82131 10.6094C8.43068 10.6094 8.84963 10.9966 8.84963 11.5488C8.84963 12.082 8.43068 12.4756 7.82131 12.4756Z"
																	fill="#6390C3"
																	fill-rule="evenodd"
																/>
															</svg>
														</div>
														<template #content>
															<div
																class="max-w-lg"
															>
																Mục tiêu trong
																Kế hoạch hiện
																tại đã dạy thì
																không thể bị xóa
																khỏi Kế hoạch
																hiện tại
															</div>
														</template>
													</Popper>
												</div>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else class="w-full px-6">
		<div class="py-12 flex items-center justify-between">
			<div class="text-3xl font-bold text-neutral-500 whitespace-nowrap">
				Mục tiêu hoàn thành
			</div>
			<div class="cursor-pointer">
				<svg
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
					@click="$emit('close')"
				>
					<path
						clip-rule="evenodd"
						d="M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z"
						fill="#94A3B8"
						fill-rule="evenodd"
					/>
				</svg>
			</div>
		</div>
		<div class="p-6 bg-white rounded-2xl">
			<div>
				<div class="flex items-center justify-between mb-4">
					<div class="font-semibold text-neutral-500">
						Thống kê chung
					</div>
				</div>
			</div>
			<div class="grid grid-cols-1 md:grid-cols-2">
				<div
					class="
						p-3
						border
						md:rounded-l-lg
						border-neutral-200
						w-full
						md-down:rounded-t md-down:rounded-b-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						{{ skills_count__completed }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số lĩnh vực
						</span>
					</div>
				</div>
				<div
					class="
						p-3
						border
						md-down:border-t-0
						md:border-l-0 md:rounded-r-lg
						border-neutral-200
						w-full
						md-down:rounded-b md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-1
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2 mb-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ goals_count__completed }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng mục tiêu
						</span>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div
				v-for="(goal, index) in goals__completed"
				:key="index"
				class="my-10"
			>
				<div class="font-semibold text-lg text-neutral-600 mb-4">
					{{ index + 1 }}. {{ goal.skill.name }} ({{
						goal.goals.length
					}})
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden">
					<div class="__record__table overflow-x-auto scroll-bar">
						<div class="overflow-hidden sm:rounded-t-2xl">
							<table class="divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
												whitespace-nowrap
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												w-full
											"
											scope="col"
											style="min-width: 160px"
										>
											Nội dung
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(g, i) in goal.goals"
										:key="g.goal_id || g.id"
										:class="
											i % 2 === 0
												? 'bg-white'
												: 'bg-neutral-50'
										"
										class="text-neutral-700"
									>
										<td
											class="
												px-6
												py-4
												whitespace-nowrap
												text-neutral-700
											"
										>
											<div class="ml-2">
												{{ i + 1 }}
											</div>
										</td>
										<td class="px-6 py-4 text-neutral-700">
											<div
												class="
													flex
													items-center
													justify-between
												"
											>
												<router-link
													:to="`/goal/${id}/${g.id}`"
												>
													<div v-html="g.name"></div>
												</router-link>
												<TooltipGoalDetail
													:goal-id="g.goal_id || g.id"
													:student-id="id"
												/>
											</div>
											<div
												v-if="
													(g?.assistance_levels &&
														org.enable_goal_assistance_level) ||
													g?.raw_source
												"
												class="flex gap-2 flex-wrap"
												style="max-width: 360px"
											>
												<div
													v-if="g?.raw_source"
													class="
														mt-1
														py-0.5
														px-2.5
														rounded-full
														bg-neutral-200
														text-neutral-700
														h-fit
														w-fit
														whitespace-nowrap
														font-semibold
														shadow-input
													"
													style="font-size: 10px"
												>
													{{ g?.display_source }}
												</div>
												<template
													v-if="
														g?.assistance_levels &&
														org.enable_goal_assistance_level
													"
												>
													<div
														v-for="ass in g?.assistance_levels"
														:key="ass"
														class="flex gap-2"
													>
														<div
															class="
																mt-1
																py-0.5
																px-2.5
																rounded-full
																bg-pink-100
																whitespace-nowrap
																text-neutral-700
																h-fit
																w-fit
																font-semibold
																shadow-input
															"
															style="
																font-size: 10px;
															"
														>
															{{ ass }}
														</div>
													</div>
												</template>
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { computed, defineComponent, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { $api } from '@/services';
import { useStore } from 'vuex';
import { useStudent } from '@/features/student/useStudent';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import DeleteConfirm from '@/components/modules/reportTargetFuture/DeleteConfirm.vue';
import EditGoalSideOver from '@/components/elements/editGoalSideOver/EditGoalSideOver.vue';
import TooltipGoalDetail from '@/components/elements/tooltipGoalDetail/TooltipGoalDetail.vue';
import ChangeApplyDate from './ChangeApplyDate.vue';
import Popper from 'vue3-popper';

export default defineComponent({
	name: 'PlanFutureSlideOver',
	components: {
		TooltipGoalDetail,
		EditGoalSideOver,
		DeleteConfirm,
		DaModalFrame,
		Popper,
		ChangeApplyDate,
	},
	props: {
		isCompleted: {
			type: Boolean,
			default: false,
		},
		isUpdated: {
			type: Boolean,
			default: false,
		},
	},

	setup(props, { emit }) {
		const route = useRoute();
		const store = useStore();

		const id = computed(() =>
			route.params?.id ? route.params?.id + '' : ''
		);

		//
		const data = ref(null);
		const goals = ref(null);
		const goals_count = ref(0);
		const skills_count = ref(0);
		const continued_goals_count = ref(0);
		const goals_from_lib_count = ref(0);
		const goals_from_stopped_count = ref(0);
		const new_goals_count = ref(0);
		const openModal = ref(false);

		async function planSchedule() {
			try {
				const {
					data: { data: data_report, stats, skills },
				} = await $api.monthlyReport.planActive(id.value);
				data.value = data_report;
				goals.value = skills.continued;
				goals_count.value = stats.goals_count;
				skills_count.value = stats.skills_count;
				continued_goals_count.value = stats.continued_goals_count;
				goals_from_lib_count.value = stats.goals_from_lib_count;
				goals_from_stopped_count.value = stats.goals_from_stopped_count;
				new_goals_count.value = stats.new_goals_count;
			} catch (e) {
				console.log(e);
			}
		}

		const plan_id = computed(() =>
			route.params?.plan_id ? String(route.params?.plan_id) : ''
		);
		const student_id = computed(() =>
			route.params?.id ? route.params?.id + '' : ''
		);

		async function deleteGoal(id) {
			try {
				await $api.goal.deleteGoal(id, student_id.value, plan_id.value);
				await planSchedule();
				await store.dispatch('setAlertMessage', {
					message: 'Đã xoá mục tiêu thành công',
				});
				isSuccess.value = true;
				await store.dispatch('removeGoal', id);
				await store.dispatch('reload');
				closeModal();
			} catch (e) {
				await store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		}

		watch(
			() => props.isUpdated,
			(value) => {
				if (value) {
					planSchedule();
					emit('updated');
				}
			}
		);

		//
		const { goalCompletedByStudent } = useStudent();

		const goals__completed = ref([]);
		const skills_count__completed = ref(0);
		const goals_count__completed = ref(0);

		//
		async function fetchGoals() {
			const res = await goalCompletedByStudent(id.value);
			if (res?.data) {
				goals__completed.value = res?.data.skills ?? [];
				skills_count__completed.value = res?.data?.skills.length;
				goals__completed.value.forEach((item) => {
					goals_count__completed.value += item?.goals.length || 0;
				});
			}
		}

		const modalIsOpen = ref(false);
		const idSelected = ref('');
		const isSuccess = ref(false);
		const isNoRepeat = ref(false);
		const isReteach = ref(false);
		const isNoRepeatReTeach = ref(false);
		const isEditModal = ref(false);

		function deleting(id, reteach = false) {
			if (reteach && isNoRepeatReTeach.value) {
				deleteGoal(id);
				closeModal();
				return;
			}
			if (!reteach && isNoRepeat.value) {
				deleteGoal(id);
				closeModal();
				return;
			}
			idSelected.value = id;
			modalIsOpen.value = true;
			isSuccess.value = false;
			isEditModal.value = false;
			isReteach.value = reteach;
		}

		let editData = ref(null);
		const tabActive = ref(null);

		async function editGoalModal(data) {
			editData.value = {
				id: data?.id || data?.goal_id,
				name: data?.name || data?.goal_name,
			};
			isEditModal.value = true;
			if (!data?.editable) {
				tabActive.value = 1;
			} else {
				tabActive.value = null;
			}
		}

		function closeModal() {
			modalIsOpen.value = false;
			idSelected.value = '';
			isSuccess.value = false;
			isEditModal.value = false;
			openModal.value = false;
		}

		function closeModelParent() {
			if (isReteach.value) {
				isNoRepeatReTeach.value = false;
			} else {
				isNoRepeat.value = false;
			}
			closeModal();
		}

		const errorEdit = ref('');

		async function editSubmit(data) {
			try {
				const res = await $api.goal.updateGoal(id.value, data.id, {
					goal: data,
				});
				if (res?.data) {
					closeModal();
					await planSchedule();
					await store.dispatch('setAlertMessage', {
						message: 'Chỉnh sửa mục tiêu thành công',
					});
				}
			} catch (e) {
				errorEdit.value = e?.response?.data?.errors_by_field || '';
			}
		}

		const skills = ref([]);

		async function fetchSkill() {
			try {
				const res = await $api.goal.allSkills();
				if (res?.data) {
					skills.value = res?.data?.data;
				}
			} catch (e) {
				console.log(e);
			}
		}
		
		function openChangeApplyDate() {
			modalIsOpen.value = true;
			openModal.value = true;
		}

		function changeDate() {
			closeModal();
			planSchedule()

		}
		const isShow = ref(true);

		fetchGoals();
		planSchedule();
		fetchSkill();

		return {
			id,
			plan_id,
			student_id,
			isShow,
			isReteach,
			isNoRepeat,
			isNoRepeatReTeach,
			modalIsOpen,
			idSelected,
			isSuccess,
			errorEdit,
			editData,
			isEditModal,
			skills,
			deleting,
			closeModal,
			closeModelParent,
			editSubmit,
			editGoalModal,
			data,
			goals,
			goals_count,
			skills_count,
			continued_goals_count,
			goals_from_lib_count,
			goals_from_stopped_count,
			new_goals_count,
			goals__completed,
			skills_count__completed,
			goals_count__completed,
			stop,
			deleteGoal,
			tabActive,
			org: computed(() => store.state.profile.current_org),
			changeDate,
			openModal,
			openChangeApplyDate,
		};
	},
});
</script>
<style scoped>
.goal-block {
	background: #eef3f8;
	padding: 12px;
	border-radius: 8px;
	border: 1px solid #bacde4;
}
</style>
